import { useRef, useState } from "react";
import styles from "./FileAttachment.module.scss";
import { GoPaperclip } from "react-icons/go";

const FileAttachment = ({ id, setFile }) => {
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState('')

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setFile(event.target.files[0])
      setFileName(event.target.files[0].name)
    }
  };

  return (
    <div>
      <input type="file" className="hidden" id={id || ''} name={id || ''} ref={fileInputRef} onChange={handleFileChange} />

      <div className={styles.fileDisplay} onClick={handleClick}>
        <span>{fileName || "Select a file..."}</span>
        <GoPaperclip className={styles.icon} />
      </div>
    </div>
  );
};

export default FileAttachment;
